import { render } from "./PerformerProperty.vue?vue&type=template&id=4f146b86&ts=true"
import script from "./PerformerProperty.vue?vue&type=script&lang=ts"
export * from "./PerformerProperty.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__